import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import { colors } from "../setupUtils";
import { Divider,TextField,IconButton } from "@mui/material";
import AutoComplete from "./AutoComplete";
import EditIndividualCustomerDate from "./EditIndividualCustomerDate";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCGState } from "../Customer/customerGroupSetupSlice";
import { useEffect } from "react";
import dayjs from "dayjs";
import CloseIcon from '@mui/icons-material/Close';


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1300,
  height: 560,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export default function BasicModal() {
  const dispatch=useDispatch();
  const cgState = useSelector((store) => store.customerGroupSetup);
  const { selCustomers, editFromDate, editToDate,editIndDateUpdated } = cgState;

  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;

  const [open, setOpen] = React.useState(false);
  const [searchQuery,setSearchQuery]=useState('');
  const [tempCustomers,setTempCustomers]=useState(selCustomers);

  useEffect(()=>{
    setTempCustomers(selCustomers)
  },[selCustomers]);

  function showPopup(message, severity) {
    dispatch(setCGState("popUpMsg", message));
    dispatch(setCGState("popUpSeverity", severity));
    dispatch(setCGState("popUpOpen", true));
 }

  const handleClose = () => {
    setOpen(false);
    setTempCustomers(selCustomers);
  }

  const handleSearchChange=(event)=>{
    setSearchQuery(event.target.value);
  }

  const handleOpen=()=>{
    //console.log("The selected customers in handleopen are",selCustomers);
    const updatedCustomers = selCustomers.map((customer) => {
      if (!customer.effectiveStartDate || !customer.effectiveEndDate) {
        return {
          ...customer,
          effectiveStartDate: dayjs(editFromDate).isAfter(dayjs())
            ? editFromDate
            : dayjs().add(1, "day").format("YYYY-MM-DD"),
          effectiveEndDate: editToDate,
        };
      }
      return customer;
    });
    dispatch(setCGState("selCustomers", updatedCustomers));
    setSearchQuery("");
    setTempCustomers(updatedCustomers);
    setOpen(true);
  }

  useEffect(()=>{
    if(editIndDateUpdated){
      setTempCustomers(selCustomers);
    }
  },[editIndDateUpdated,setTempCustomers]);

  const handleSave = () => {
    let errorOccured = false;
  
    // check if any customer end date is less than start date
    const invalidCustomer = tempCustomers.find((customer) =>
      dayjs(customer.effectiveStartDate).startOf('day').isAfter(dayjs(customer.effectiveEndDate).startOf('day'))
    );
  
    if (invalidCustomer) {
      showPopup("The customer effective end date cannot be less than the start date", "error");
      setOpen(true);
      errorOccured = true;
    }
  
    if (errorOccured) return; 
  
    // Check if the effectiveStartDate falls outside the  customergroup start date
    const startDateValidationError = tempCustomers.find((customer) =>
      dayjs(customer.effectiveStartDate).startOf('day').isBefore(dayjs(editFromDate).startOf('day'))
    );
  
    if (startDateValidationError) {
      showPopup("The Customer effective start date falls outside the effective start date of customer group", "error");
      setOpen(true);
      errorOccured = true;
    }
  
    if (errorOccured) return; 
  

    const endDateValidationError = tempCustomers.find((customer) =>
      dayjs(customer.effectiveEndDate).startOf('day').isAfter(dayjs(editToDate).startOf('day'))
    );
  
    if (endDateValidationError) {
      showPopup("The Customer effective end date falls outside the effective end date of customer group", "error");
      setOpen(true);
      errorOccured = true;
    }
  
    if (errorOccured) return; 
  
    // Check if at least one customer's start date matches with the group start date
    const isStartDateMatched = tempCustomers.some((customer) =>
      dayjs(customer.effectiveStartDate).startOf('day').isSame(dayjs(editFromDate).startOf('day'))
    );
  
    if (!isStartDateMatched) {
      showPopup("At least one Customer effective start date has to match with the start date of customer group", "error");
      setOpen(true);
      errorOccured = true;
    }
  
    // Check if at least one customer's end date matches with the group end date
    const isEndDateMatched = tempCustomers.some((customer) =>
      dayjs(customer.effectiveEndDate).startOf('day').isSame(dayjs(editToDate).startOf('day'))
    );
  
    if (!isEndDateMatched) {
      showPopup("At least one Customer effective end date has to match with the end date of customer group", "error");
      setOpen(true);
      errorOccured = true;
    }
  
    if (!errorOccured) {
      dispatch(setCGState("selCustomers", tempCustomers));
      dispatch(setCGState("editIndDateUpdated", true));
      setOpen(false);
    }
  };
  const loadMore = (startIndex, stopIndex) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newItems = selCustomers.slice(startIndex, stopIndex + 1);
  
        setTempCustomers((prev) => {
          const existingIds = new Set(prev.map((c) => c.customerID));
          const merged = [...prev];
          newItems.forEach((item) => {
            if (!existingIds.has(item.customerID)) {
              merged.push(item);
            }
          });
          return merged;
        });
  
        resolve();
      }, 300);
    });
  };

  return (
    <div>
      <Button
        startIcon={<EditCalendarIcon />}
        disabled={!isRestrictedAccess}
        sx={{
          bgcolor: "darkred.light",
          color: "white.main",
          textTransform: "none",
          ml: "auto",
          mt: 3,
          mb: 3,
          // float: "right",
          "&:hover": {
            bgcolor: "darkred.main",
            color: "white.main",
          },
          marginLeft: "calc(100% - 165px)",
        }}
        onClick={handleOpen}
      >
        Update Dates
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <IconButton
          onClick={handleClose}
          sx={{
            position:'absolute',
            top:10,
            right:10,
            zIndex:1,
            color:'grey'
          }}
          >
            <CloseIcon/>
          </IconButton>
          <Typography sx={{ ml: 1, fontWeight: "bold", color: "darkred.light" }}>
            Edit Customer Start Date / End Date
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <TextField
          label="Search"
          variant="outlined"
          size="small"
          fullWidth
          sx={{mb:2,
              mt:-1,           
             "& .MuiOutlinedInput-root": {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "darkred.main !important",
            },
          },}}
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{ autoComplete: "off" }}
          />
          {/* <AutoComplete /> */}
          <EditIndividualCustomerDate
          searchQuery={searchQuery}
          tempCustomers={tempCustomers}
          setTempCustomers={setTempCustomers} 
          loadMore={loadMore}
          />
          <Box>
            <Button
              sx={{
                bgcolor: "darkred.light",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                position: "fixed",
                bottom: 10,
                right: 20,
                zIndex: 1,
                "&:hover": {
                  bgcolor: "darkred.main",
                  color: "white.main",
                },
              }}
              onClick={handleSave}
            >
              Save Dates
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
